import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiStatus } from 'src/app/model';
import { SearchCriteria } from 'src/app/model/hotel.model';
import { AppContext } from 'src/app/services/app-context.service';
import { AuthService } from 'src/app/services/auth.service';
import { HotelService } from 'src/app/services/hotel.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { DealService } from '../../services/deal.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment.prod';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'travel-ui-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  iframeurl?: SafeResourceUrl;
  banner: any;
  submitBtnDisabled = false;
  @Input()
  displaySetting: any;
  dealDefaultCriteria: any;
  // True once a brand-specific (hardcoded) deal set has been applied to dealData.
  hasStaticDeals = false;
  nobleColor = false;
  siteName: any;
  errorText = '';
  showError = false;
  selectedSearchOption = {};
  autoSuggestOptions: any;
  showLoader: boolean = false;
  dealData: any;
  siteContext: any;
  nobleDeal = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'We have selected some best locations around the world for you.',
        deals: [
          {
            id: 1,
            title: 'Rome',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/rome.jpg',
            referenceId: '435759'
          },
          {
            id: 2,
            title: 'Paris',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/paris.jpg',
            referenceId: '435758'
          },
          {
            id: 3,
            title: 'Miami',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/miami.jpg',
            referenceId: '2280'
          },
          {
            id: 4,
            title: 'Dubai',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/dubai.jpg',
            referenceId: '221688'
          },
          {
            id: 5,
            title: 'Barcelona',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/barcelona.jpg',
            referenceId: '435792'
          },
          {
            id: 6,
            title: 'Los Angeles',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/los-angeles.jpg',
            referenceId: '93759'
          },
          {
            id: 7,
            title: 'New York',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/new-york.jpg',
            referenceId: '2285'
          },
          {
            id: 8,
            title: 'Tokyo',
            desc: '',
            type: 'location',
            imageUrl:
              'https://noble-assets.s3.amazonaws.com/zentrumhub/tokyo.jpg',
            referenceId: '246750'
          }
        ]
      }
    ]
  };

  travelBrands = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'We have selected some best locations around the world for you.',
        deals: [
          {
            id: 1,
            title: 'Mexico',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2015/11/05/23/02/chichen-itza-1025099_960_720.jpg',
            referenceId: '154666'
          },
          {
            id: 2,
            title: 'Cuba',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2016/08/23/00/30/havana-1613263_960_720.jpg',
            referenceId: '426648'
          },
          {
            id: 3,
            title: 'Dominican Republic',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2016/12/05/16/28/dominican-republic-1884286_960_720.jpg',
            referenceId: '426367'
          },
          {
            id: 4,
            title: 'Caribbean',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2017/12/16/22/22/bora-bora-3023437_960_720.jpg',
            referenceId: '391386'
          },
          {
            id: 5,
            title: 'Jamaica',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2015/06/21/15/03/jamaica-816669_960_720.jpg',
            referenceId: '93366'
          },
          {
            id: 6,
            title: 'Paris',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2017/09/26/20/13/eiffel-2789943_960_720.jpg',
            referenceId: '435758'
          },
          {
            id: 7,
            title: 'Amsterdam',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2016/09/04/10/24/amsterdam-1643644_960_720.jpg',
            referenceId: '435081'
          },
          {
            id: 8,
            title: 'Zurich',
            desc: '',
            type: 'location',
            imageUrl:
              'https://cdn.pixabay.com/photo/2022/11/25/13/12/building-7616202_960_720.jpg',
            referenceId: '593029'
          }
        ]
      }
    ]
  };

  ftdDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'We have selected some best locations around the world for you.',
        deals: [
          {
            id: 1,
            title: 'Goa',
            desc: 'Sun, Sand & Sea',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/goa-hotels-ftd-travel.jpg',
            referenceId: '328959'
          },
          {
            id: 2,
            title: 'Ooty',
            desc: 'Queen of Hill Stations',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/ooty-ftd-travel.jpg',
            referenceId: '343016'
          },
          {
            id: 3,
            title: 'Jaipur',
            desc: 'Pink City',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/jaipur-hotels-ftd-travel.jpg',
            referenceId: '329163'
          },
          {
            id: 4,
            title: 'Srinagar',
            desc: 'Heaven on Earth',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/srinagar-hotels-ftd-travel.jpg',
            referenceId: '333577'
          },
          {
            id: 5,
            title: 'Dubai',
            desc: 'Darling Tourist Destination',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/dubai-hotels-ftd-travel.jpg',
            referenceId: '221688'
          },
          {
            id: 6,
            title: 'Bangkok',
            desc: 'Pulsating Nightlife',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/bangkok-hotels-ftd-travel.jpg',
            referenceId: '328619'
          },
          {
            id: 7,
            title: 'Bali',
            desc: 'Mystifying Natural Beauty',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/bali-hotels-ftd-travel.jpg',
            referenceId: '328057'
          },
          {
            id: 8,
            title: 'Kuala Lumpur',
            desc: 'Hodge Podge of Everything',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ftd-assets/kuala-lumpur-hotels-ftd-travel.jpg',
            referenceId: '228226'
          }
        ]
      }
    ]
  };

  hotelCollectionDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Las Vegas',
            desc: 'Sin City',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Las-Vegas.png',
            referenceId: '2277'
          },
          {
            id: 2,
            title: 'Miami',
            desc: 'The City of Love',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Miami.png',
            referenceId: '2280'
          },
          {
            id: 3,
            title: 'Chicago',
            desc: 'The Windy City',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Chicago.png',
            referenceId: '153301'
          },
          {
            id: 4,
            title: 'Los Angeles',
            desc: 'City of Angels',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Los-Angeles.png',
            referenceId: '93759'
          },
          {
            id: 5,
            title: 'Paris',
            desc: 'The City of Love',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Paris.png',
            referenceId: '435758'
          },
          {
            id: 6,
            title: 'New York',
            desc: 'The City that Never Sleeps',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/New-York.png',
            referenceId: '2285'
          },
          {
            id: 7,
            title: 'Cancun',
            desc: 'Life is a Party',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Cancun.png',
            referenceId: '154705'
          },
          {
            id: 8,
            title: 'Seattle',
            desc: 'The City of Goodwill',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Seattle.png',
            referenceId: '2296'
          }
        ]
      }
    ]
  };

  EroRentalsDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Miami',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Miami.png',
            referenceId: '2280'
          },
          {
            id: 2,
            title: 'Israel',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Israel.png',
            referenceId: '227540'
          },
          {
            id: 3,
            title: 'Hawai',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Hawaii.png',
            referenceId: '4251'
          },
          {
            id: 4,
            title: 'Dubai',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Dubai.png',
            referenceId: '221688'
          },
          {
            id: 5,
            title: 'Mexico',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Mexico.png',
            referenceId: '154666'
          },
          {
            id: 6,
            title: 'Colombia',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Colombia.png',
            referenceId: '171165'
          },
          {
            id: 7,
            title: 'New York',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/New-York.png',
            referenceId: '2285'
          },
          {
            id: 8,
            title: 'Bangkok',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Bangkok.png',
            referenceId: '328619'
          }
        ]
      }
    ]
  };
  topPickHotelCollection = [
    {
      referenceId: '38902781',
      name: 'Nobu Hotel Miami Beach',
      country: 'Miami Beach, USA',
      locationId: '94183',
      url: 'https://q-xx.bstatic.com/xdata/images/hotel/max500/162737267.jpg?k=8ee746e825a45d0f69234bec827551f91b6f3cee1c2559e94094f2e87316c321&o=',
      stars: 5,
      coordinates: {
        lat: 25.819675,
        long: -80.12243
      }
    },
    {
      referenceId: '41535656',
      name: '33 Seaport Hotel New York ',
      locationId: '4349',
      country: 'New York, USA',
      url: 'https://q-xx.bstatic.com/xdata/images/hotel/max500/460282320.jpg?k=330751000a3260d2684b4fdb75a13fd7077c0927c50c4b4ad006ca6fba6182ea&o=',
      stars: 5,
      coordinates: {
        lat: 40.7079,
        long: -74.001495
      }
    },
    {
      referenceId: '39626905',
      name: 'The Peninsula Beverly Hills',
      country: 'Los Angeles, USA',
      locationId: '93759',
      url: 'https://q-xx.bstatic.com/xdata/images/hotel/max500/215363191.jpg?k=0e5942f666a4889bda59d0a7ecf609a224cf8ed8ead0853a5d5a15982e20787b&o=',
      stars: 5,
      coordinates: {
        lat: 34.066113,
        long: -118.40222
      }
    }
  ];

  shamalGroupDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Cape Town',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Cape+Town-01.jpg',
            link: 'https://shamaltravels.com/hotels-cape-town/'
          },
          {
            id: 2,
            title: 'Delhi',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/India-02.jpg',
            link: 'https://shamaltravels.com/hotels-delhi/'
          },
          {
            id: 3,
            title: 'Dubai',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Dubai-04.jpg',
            link: 'https://shamaltravels.com/hotels-dubai/'
          },
          {
            id: 4,
            title: 'Bali',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Bali-05.jpg',
            link: 'https://shamaltravels.com/hotels-bali/'
          },
          {
            id: 5,
            title: 'Bangkok',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Bangkok-06.jpg',
            link: 'https://shamaltravels.com/hotels-bangkok/'
          },
          {
            id: 6,
            title: 'Spain',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Spain+%26+Portugal-03.jpg',
            link: 'https://shamaltravels.com/hotels-spain/'
          },
          {
            id: 7,
            title: 'Mauritius',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Cancun.png',
            link: 'https://shamaltravels.com/hotels-mauritius/'
          },
          {
            id: 8,
            title: 'Vietnam',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Vietnam.jpg',
            link: 'https://shamaltravels.com/hotels-vietnam/'
          }
        ]
      }
    ]
  };

  hostMyTripsDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Goa',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Goa.jpg',
            referenceId: '328959'
          },
          {
            id: 2,
            title: 'Ooty',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Ooty.jpg',
            referenceId: '343016'
          },
          {
            id: 3,
            title: 'Jaipur',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Jaipur.jpg',
            referenceId: '329163'
          },
          {
            id: 4,
            title: 'Kashmir',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Kashmir.jpg',
            referenceId: '333577'
          },
          {
            id: 5,
            title: 'Lonavala',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Lonavala.jpg',
            referenceId: '333732'
          },
          {
            id: 6,
            title: 'Shimla',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Shimla.jpg',
            referenceId: '246679'
          },
          {
            id: 7,
            title: 'Agra',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Agra.jpg',
            referenceId: '333634'
          },
          {
            id: 8,
            title: 'Alleppey',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/PopularDestinations/Alleppey.jpg',
            referenceId: '286076'
          }
        ]
      }
    ]
  };

  oneStopParking = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Orlando',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/orlando.png',
            referenceId: '2286'
          },
          {
            id: 2,
            title: 'New York',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/newyork.png',
            referenceId: '2285'
          },
          {
            id: 3,
            title: 'Chicago',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/chicago.png',
            referenceId: '153301'
          },
          {
            id: 4,
            title: 'Las Vegas',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/lasvegas.png',
            referenceId: '4221'
          },
          {
            id: 5,
            title: 'Montreal',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/montreal.png',
            referenceId: '95787'
          },
          {
            id: 6,
            title: 'Paris',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/paris.png',
            referenceId: '437227'
          },
          {
            id: 7,
            title: 'Mexico',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/mexico.png',
            referenceId: '163264'
          },
          {
            id: 8,
            title: 'Yellowstone',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/PopularDestination/yellowstone.png',
            referenceId: '66406'
          }
        ]
      }
    ]
  };

  secretScapades = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Thailand',
            desc: '',
            type: 'location',
            imageUrl:
              '	https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/roamTo-Assets/Thailand.jpg',
            referenceId: '227765'
          },
          {
            id: 2,
            title: 'Bali',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/roamTo-Assets/Bali.jpg',
            referenceId: '328057'
          },
          {
            id: 3,
            title: 'Singapore',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/SecretEscapades/singapore.jpg',
            referenceId: '246673'
          },
          {
            id: 4,
            title: 'Goa',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/SecretEscapades/goa.jpg',
            referenceId: '328959'
          },
          {
            id: 5,
            title: 'Maldives',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/roamTo-Assets/Maldives.jpg',
            referenceId: '227609'
          },
          {
            id: 6,
            title: 'Tokyo',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/SecretEscapades/tokyo.png',
            referenceId: '246750'
          }
        ]
      }
    ]
  };

  dreampassDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Manila',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/manila.jpg',
            referenceId: '227787'
          },
          {
            id: 2,
            title: 'New York',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/New-York.png',
            referenceId: '2285'
          },
          {
            id: 3,
            title: 'Delhi',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/India-02.jpg',
            referenceId: '227768'
          },
          {
            id: 4,
            title: 'Lagos',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/Lagos.webp',
            referenceId: '612064'
          },
          {
            id: 5,
            title: 'Los Angeles',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Los-Angeles.png',
            referenceId: '2278'
          },
          {
            id: 6,
            title: 'Mumbai',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/mumbai.webp',
            referenceId: '328995'
          },
          {
            id: 7,
            title: 'Istanbul',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/istanbul.jpg',
            referenceId: '213455'
          },
          {
            id: 8,
            title: 'Toronto',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/toronto.jpg',
            referenceId: '12946'
          }
        ]
      }
    ]
  };

  asapticketsDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Manila',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/manila.jpg',
            referenceId: '227787'
          },
          {
            id: 2,
            title: 'Lagos',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/Lagos.webp',
            referenceId: '612064'
          },
          {
            id: 3,
            title: 'New York',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/New-York.png',
            referenceId: '2285'
          },
          {
            id: 4,
            title: 'Cebu',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/cebu.jpg',
            referenceId: '360546'
          },
          {
            id: 5,
            title: 'Accra',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/accra.webp',
            referenceId: '379963'
          },
          {
            id: 6,
            title: 'Los Angeles',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Los-Angeles.png',
            referenceId: '2278'
          },
          {
            id: 7,
            title: 'Delhi',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/India-02.jpg',
            referenceId: '227768'
          },
          {
            id: 8,
            title: 'Nairobi',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/Nairobi.jpg',
            referenceId: '364653'
          }
        ]
      }
    ]
  };

  skyluxDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Delhi',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/India-02.jpg',
            referenceId: '227768'
          },
          {
            id: 2,
            title: 'London',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/london.jpg',
            referenceId: '437162'
          },
          {
            id: 3,
            title: 'Mumbai',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/mumbai.webp',
            referenceId: '328995'
          },
          {
            id: 4,
            title: 'Rome',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/rome.jpg',
            referenceId: '480608'
          },
          {
            id: 5,
            title: 'Istanbul',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/istanbul.jpg',
            referenceId: '213455'
          },
          {
            id: 6,
            title: 'Paris',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/Paris.png',
            referenceId: '437227'
          },
          {
            id: 7,
            title: 'Tokyo',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/tokyo.webp',
            referenceId: '246750'
          },
          {
            id: 8,
            title: 'Athens',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/athens.jpg',
            referenceId: '60416'
          }
        ]
      }
    ]
  };

  oojoDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Manila',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/manila.jpg',
            referenceId: '227787'
          },
          {
            id: 2,
            title: 'New York',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/hotelcollection-assets/New-York.png',
            referenceId: '2285'
          },
          {
            id: 3,
            title: 'Delhi',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/India-02.jpg',
            referenceId: '227768'
          },
          {
            id: 4,
            title: 'Toronto',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/toronto.jpg',
            referenceId: '12946'
          },
          {
            id: 5,
            title: 'Cairo',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/cairo.jpg',
            referenceId: '364417'
          },
          {
            id: 6,
            title: 'Bangkok',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Bangkok.png',
            referenceId: '328619'
          },
          {
            id: 7,
            title: 'Mumbai',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/mumbai.webp',
            referenceId: '328995'
          },
          {
            id: 8,
            title: 'Istanbul',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/istanbul.jpg',
            referenceId: '213455'
          }
        ]
      }
    ]
  };


  vagamoDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'The best hotels and destinations chosen by our travelers.',
        deals: [
          {
            id: 1,
            title: 'Manila',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/manila.jpg',
            referenceId: '227787'
          },
          {
            id: 2,
            title: 'Lagos',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/Lagos.webp',
            referenceId: '612064'
          },
          {
            id: 3,
            title: 'Addis Ababa',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/addis+ababa.jpg',
            referenceId: '379804'
          },
          {
            id: 4,
            title: 'Accra',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/accra.webp',
            referenceId: '379963'
          },
          {
            id: 5,
            title: 'Cairo',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/cairo.jpg',
            referenceId: '364417'
          },
          {
            id: 6,
            title: 'Bangkok',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/EroRentals/PopularDestinations/Bangkok.png',
            referenceId: '328619'
          },
          {
            id: 7,
            title: 'Nairobi',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/Nairobi.jpg',
            referenceId: '364653'
          },
          {
            id: 8,
            title: 'Monrovia',
            desc: '',
            type: 'location',
            imageUrl: 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/trevolution/Monrovia.webp',
            referenceId: '47551'
          }
        ]
      }
    ]
  };
  reckitDeals = {
    defaultCriteria: {
      room: 1,
      adult: 2
    },
    groups: [
      {
        title: 'Popular Destinations',
        desc: 'Discover your next destination.',
        deals: [
          {
            id: 1,
            title: 'Nashville',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-Nashville.avif',
            referenceId: '2283',
          },
          {
            id: 2,
            title: 'Atlanta',
            desc: '',
            type: 'location',
            imageUrl:
              'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-Atlanta.avif',
            // referenceId: '54299',
            referenceId: '2260',
          },
          {
            id:3,
            title: 'New York',
            desc: '',
            type : 'location',
            imageUrl : 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-NewYork.avif',
            referenceId : '4349'
          },
          {
            id:4,
            title: 'Miami',
            desc: '',
            type : 'location',
            imageUrl : 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-Miami.avif',
            referenceId : '153760'
          },
          {
            id:5,
            title: 'Chicago',
            desc: '',
            type : 'location',
            imageUrl : 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-Chicago.avif',
            referenceId : '153301'
          },
          {
            id:6,
            title: 'San Francisco',
            desc: '',
            type : 'location',
            imageUrl : 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-SanFrancisco.avif',
            referenceId : '12664'
          },
          {
            id:7,
            title: 'Boston',
            desc: '',
            type : 'location',
            imageUrl : 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-Boston.avif',
            referenceId : '2263'
          },
          {
            id:8,
            title: 'Washington D.C.',
            desc: '',
            type : 'location',
            imageUrl : 'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Reckit/reckit-popular-destinations/reckit-WashingtonDC.avif',
            referenceId : '27744'
          }

        ]
      }
    ]
  };


  ipAddress: any = '';

  _searchCriteria = new SearchCriteria();
  bannerText: any;
  bannerText2?: string;
  bannerText1?: string;
  get searchCriteria(): SearchCriteria {
    return this._searchCriteria;
  }
  set searchCriteria(val: any) {
    this._searchCriteria = new SearchCriteria(val);
  }

  supportNumber: string = '';
  mobileBannerB2C: string =
    'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Hotel+B2C+Banner+Square-28.jpg';
  mobileBannerB2B: string =
    'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Hotel+B2B+Banner+Square-32.jpg';

  shamalGroupList = [
    {
      text: 'Over 3 million hotels in 170+ countries',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/3M+in+170%2B.png'
    },
    {
      text: 'Instant payments & confirmations',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Instant+Booking.png'
    },
    {
      text: '24/7 assistance with Shamal Travels',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/24_7+Assitance+.png'
    },
    {
      text: 'Manage your bookings on the go',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/ShamalGroup/Manage+on+the+go.png'
    }
  ];

  hostMyTripsGroupList = [
    {
      text: 'Assured Assistance',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/header%26branding-images/telephone.png'
    },
    {
      text: 'Assured Breakfast',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/header%26branding-images/breakfast.png'
    },
    {
      text: 'Assured Travel Counsellor',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/header%26branding-images/man_4140059.png'
    },
    {
      text: 'Assured Satisfaction',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/Host-My-Trips/header%26branding-images/review.png'
    }
  ];

  oneStopParkingGroupList = [
    {
      text: 'Exclusive Deals',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/exclusivedeals.png'
    },
    {
      text: 'Seamless Booking',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/seamlessbooking.png'
    },
    {
      text: 'Earn Loyalty Points',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/loyaltypoint.png'
    },
    {
      text: 'Customer Service',
      image:
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/onestopparking/customerservice.png'
    }
  ];

  getIframeUrl(): SafeResourceUrl {
    let unsafeIframeUrl = `https://search-widget.dev.prod.zentrumhub.com/?redirecturl=${window.location.protocol}//${window.location.host}/hotels/results&apikey=TESTKEY&primarycolor=%230000ff&primarycolortint=%239999ff`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeIframeUrl);
  }

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private hotelService: HotelService,
    private dealSvc: DealService,
    public appContext: AppContext,
    private toasterSvc: ToasterService,
    public auth: AuthService,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.contextInitializer();
    this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        let params = new URLSearchParams(fragment);
        let accessToken = params.get('access_token');
        let type = params.get('type');
        let refreshToken = params.get('refresh_token');

        if (accessToken && type === 'recovery') {
          window.location.href = `/login/update-password?token=${accessToken}&refresh_token=${refreshToken}`;
        }
      }
    });
  }

  contextInitializer() {
    let str: any;
    this.iframeurl = this.getIframeUrl();
    str = JSON.parse(sessionStorage.getItem('SiteContext') as string);
    this.siteContext = str;
    this.siteName = str.name;
    this.supportNumber = str.displaySetting.header?.navText;
    this.bannerText = str.displaySetting.header?.bannerText;
    if (this.bannerText) {
      const [part1, part2] = this.splitBannerText(this.bannerText, 32);
      this.bannerText1 = part1;
      this.bannerText2 = part2;
    }

    if (this.siteContext?.displaySetting?.bannerImage) {
      this.showLoader = true;
      this.banner = this.siteContext?.displaySetting?.bannerImage;
      if (this.siteName == 'ShamalGroup') {
        this.updateBackgroundImage();
      }
      if (this.siteName == 'EroRentals') {
        this.playVideo();
      }
    } else {
      this.showLoader = true;
      this.banner =
        'https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/JoyLife/JoyLife-Banner.jpeg';
    }
    this.getIPAddress();

    // this.roomConfig = this.hotelService.roomConfig;
    this.selectedSearchOption = this.hotelService.selectedSearchOption;

    setTimeout(() => {
      // Every branch below ships its own hardcoded deal set; only the final
      // `else` fetches from the API. `hasStaticDeals` keeps the destinations
      // section visible for those brands even when the backend does not send
      // siteContext.enablePopularDestinations.
      this.hasStaticDeals = true;
      if (this.appContext.siteName == 'TravelBrands') {
        this.dealDefaultCriteria = this.travelBrands.defaultCriteria;
        this.dealData = this.travelBrands.groups;
      } else if (this.appContext.siteName == 'NobleStay') {
        this.dealDefaultCriteria = this.nobleDeal.defaultCriteria;
        this.dealData = this.nobleDeal.groups;
      } else if (this.appContext.siteName == 'HotelCollection') {
        this.dealDefaultCriteria = this.hotelCollectionDeals.defaultCriteria;
        this.dealData = this.hotelCollectionDeals.groups;
      } else if (this.appContext.siteName == 'ShamalGroup') {
        this.dealDefaultCriteria = this.shamalGroupDeals.defaultCriteria;
        this.dealData = this.shamalGroupDeals.groups;
      } else if (this.appContext.siteName == 'HostMyTrips') {
        this.dealDefaultCriteria = this.hostMyTripsDeals.defaultCriteria;
        this.dealData = this.hostMyTripsDeals.groups;
      } else if (this.appContext.siteName == 'OneStopParking') {
        this.dealDefaultCriteria = this.oneStopParking.defaultCriteria;
        this.dealData = this.oneStopParking.groups;
      } else if (this.appContext.siteName == 'SecretEscapades') {
        this.dealDefaultCriteria = this.secretScapades.defaultCriteria;
        this.dealData = this.secretScapades.groups;
      } else if (this.appContext.siteName == 'Dreampass') {
        this.dealDefaultCriteria = this.dreampassDeals.defaultCriteria;
        this.dealData = this.dreampassDeals.groups;
      } else if (this.appContext.siteName == 'Vagamo') {
        this.dealDefaultCriteria = this.vagamoDeals.defaultCriteria;
        this.dealData = this.vagamoDeals.groups;
      } else if (this.appContext.siteName == 'Skylux') {
        this.dealDefaultCriteria = this.skyluxDeals.defaultCriteria;
        this.dealData = this.skyluxDeals.groups;
      } else if (this.appContext.siteName == 'Oojo') {
        this.dealDefaultCriteria = this.oojoDeals.defaultCriteria;
        this.dealData = this.oojoDeals.groups;
      } else if (this.appContext.siteName == 'Asaptickets') {
        this.dealDefaultCriteria = this.asapticketsDeals.defaultCriteria;
        this.dealData = this.asapticketsDeals.groups;
      } else if (this.appContext.siteName == 'EroRentals') {
        this.dealDefaultCriteria = this.EroRentalsDeals.defaultCriteria;
        this.dealData = this.EroRentalsDeals.groups;
      } else if(this.appContext.siteName == 'Sharecare'){
        this.dealData = this.reckitDeals.groups;
        this.dealDefaultCriteria = this.reckitDeals.defaultCriteria;
      }
       else {
        this.hasStaticDeals = false;
        this.dealSvc.getDeal().subscribe({
          next: (res: any) => {
            if (res.status !== ApiStatus.Success) {
              this.dealData = [];
              return;
            }
            this.dealDefaultCriteria = res.response.defaultCriteria;
            this.dealData = res.response.groups;
          },
          error: () => {
            this.dealData = [];
          }
        });
      }
    }, 3000);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.siteName == 'ShamalGroup') this.updateBackgroundImage();
  }

  updateBackgroundImage() {
    if (window.innerWidth <= 767) {
      if (this.siteContext.displaySetting?.pageTitlePrefix == 'ShamalGroup-B2B')
        this.banner = this.mobileBannerB2B;
      else this.banner = this.mobileBannerB2C;
    } else {
      this.banner = this.banner;
    }
  }

  getIPAddress() {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.ipAddress = res.ip;
      });
  }
  // getDeals(res: any) {
  //   const dealsList: any[] = [];
  //   res.forEach((item: any) => {
  //     const data = {
  //       desc: item.desc,
  //       fromPrice: item.fromPrice,
  //       id: item.id,
  //       imageUrl: item.imageUrl,
  //       locationId: item.locationId,
  //       fullName: item.title
  //     };
  //     dealsList.push(data);
  //   });
  //   return dealsList;
  // }

  playVideo() {
    setTimeout(() => {
      document.getElementsByTagName('video')[0]?.play();
    }, 3000);
  }

  goToResultsPage(e: any) {
    if (!e.searchCriteria && !e.searchSelectedOption) {
      return;
    }
    this.hotelService.searchId = '';
    this.hotelService.searchTracingKey = '';
    this.hotelService.searchCriteria = e.searchCriteria;
    this.hotelService.selectedSearchOption = e.searchSelectedOption;
    // setting items in local storage
    this.hotelService.updateStateInLocalStorage({
      // 'roomConfig': this.roomConfig,
      selectedSearchOption: e.searchSelectedOption,
      searchCriteria: e.searchCriteria
    });

    if (
      e.searchCriteria.locationId &&
      e.searchCriteria.checkIn &&
      e.searchCriteria.checkOut &&
      e.searchCriteria.rooms.length
    ) {
      this.submitBtnDisabled = true;

      // redirecting to details page when type is hotel

      if (e.searchSelectedOption.type === 'hotel') {
        const truncatedHotelName = this.transform(e.searchCriteria.fullName);
        const hotelname = truncatedHotelName.replace(/" "|\s/g, '-');
        this.hotelService.isSeachTypeHotel = true;

        this.router.navigate(
          ['hotels', e.searchSelectedOption.referenceId, hotelname],
          {
            queryParams: this.hotelService.getSearchResultQueryParam()
          }
        );
      } else {
        // Normal hotel search flow
        this.hotelService.isSeachTypeHotel = false;
        this.hotelService.initSearch('', this.ipAddress).subscribe(
          (res: any) => {
            if (res.status === 'success') {
              if (!res.searchId) {
                this.toasterSvc.error('Oops, something went wrong !');
                return;
              }

              this.router.navigate(['hotels/results', res.searchId], {
                queryParams: this.hotelService.getSearchResultQueryParam()
              });
            } else {
              this.dispalyError(res.message);
            }
            this.submitBtnDisabled = false;
          },
          (err) => {
            console.error(err);
          }
        );
      }
    } else {
      this.dispalyError('Please select all fields.');
    }
  }

  dispalyError(message: string): void {
    this.errorText = message;
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 3000);
  }

  transform(value: string): string {
    let newVal = value.replace(/[^\w\s]/gi, '');
    return newVal.charAt(0).toUpperCase() + newVal.slice(1);
  }

  onDealSelect(e: any) {
    if (
      (!this.auth.isLoggedIn &&
        this.appContext.siteName != 'Prestigate' &&
        this.appContext.siteName != '30Sundays' &&
        this.appContext.siteName != 'NobleStay' &&
        this.appContext.siteName !== 'ShamalGroup' &&
        this.appContext.siteAccountId != 'zentrum-demo-account' &&
        this.appContext.siteName !== 'SecretEscapades') ||
      this.appContext.siteName == 'Gocaribbea' ||
      this.appContext?.siteName == "BookMyGetaway" ||
      this.appContext?.siteName == "BookMyGataway" ||
      this.appContext?.siteName == "Sharecare" ||
      this.appContext.siteName == 'ReservationsExpert' ||
      this.appContext.siteName == 'EroRentals' ||
      this.appContext?.siteName == 'alldotgay' ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'Prestigate') ||
      (this.auth.isLoggedIn && this.appContext.siteName == '30Sundays') ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'SecretEscapades') ||
      (this.auth.isLoggedIn && this.appContext.siteName == 'NobleStay') ||
      (this.auth.isLoggedIn &&
        this.appContext.siteAccountId == 'zentrum-demo-account')
    ) {
      if (e.type == 'location') {
        var criteria = new SearchCriteria();
        criteria.rooms = [
          {
            adults: this.dealDefaultCriteria.adult,
            children: this.dealDefaultCriteria.children,
            childAges: this.dealDefaultCriteria.childAges
          }
        ];

        criteria.locationId = e.referenceId;
        criteria.fullName = e.title;

        this.goToResultsPage({
          searchSelectedOption: e,
          searchCriteria: criteria
        });
      }
    } else if (this.appContext.siteName == 'ShamalGroup') {
      window.open(e.link, '_blank');
    } else {
      this.toasterSvc.error('Please make sure you are logged in.');
    }
  }

  getSearchOptions(searchStr: any) {
    this.hotelService.getAutosuggestOptions(searchStr).subscribe((res: any) => {
      this.autoSuggestOptions = res['locations'];
    });
  }

  toppick(hot: any) {
    let today = new Date();

    let CheckInDays = 30;
    let CheckOutDays = 31;
    let newCheckinDate = new Date(
      today.getTime() + CheckInDays * 24 * 60 * 60 * 1000
    );
    let newCheckoutDate = new Date(
      today.getTime() + CheckOutDays * 24 * 60 * 60 * 1000
    );
    let start = moment(newCheckinDate).format('YYYYMMDD');
    let end = moment(newCheckoutDate).format('YYYYMMDD');

    const truncatedHotelName = this.transform(hot.name + ' ' + hot.country);
    const hotelname = truncatedHotelName?.replace(/" "|\s/g, '-');
    let query =
      'hotels/' +
      hot.referenceId +
      '/' +
      hotelname +
      '?checkin=' +
      start +
      '&checkout=' +
      end +
      '&locationid=' +
      hot.locationId +
      '&adults=' +
      '2';

    this.searchCriteria = {
      checkIn: this._searchCriteria.checkIn,
      checkOut: this._searchCriteria.checkOut,
      countryOfResidence: environment.countryOfResidence,
      culture: 'en-us',
      isSearchByHotel: true,
      fullName: hot.name,
      locationId: hot.locationId,
      nationality: environment.countryOfResidence,
      referenceId: hot.referenceId,
      rooms: [
        {
          adults: 2,
          childAges: [],
          children: 0
        }
      ]
    };
    let selectedSearchOption = {
      city: hot.location,
      coordinates: {
        lat: hot.coordinates.lat,
        long: hot.coordinates.long
      },
      country: hot.country,
      fullName: hot.name,
      id: hot.locationId,
      name: hot.name,
      referenceId: hot.referenceId,
      score: 0,
      type: 'hotel'
    };

    this.hotelService.updateStateInLocalStorage({
      searchCriteria: this.searchCriteria,
      selectedSearchOption: selectedSearchOption
    });

    window.open('https://travel.hotelcollection.com/' + query);
  }

  splitBannerText(text: string, maxLength: number) {
    if (text.length <= maxLength) {
      return [text];
    }
    let breakPoint = text.lastIndexOf(' ', maxLength);
    if (breakPoint === -1) {
      breakPoint = maxLength;
    }
    const firstPart = text.substring(0, breakPoint);
    const secondPart = text.substring(breakPoint).trim();

    return [firstPart, secondPart];
  }
}
